const firebaseConfig = {
    apiKey: "AIzaSyA2VimvQ_JDraBd3PsEV7GnIwUc6qez-Hs",
    authDomain: "medi-cares.firebaseapp.com",
    projectId: "medi-cares",
    storageBucket: "medi-cares.appspot.com",
    messagingSenderId: "475410205800",
    appId: "1:475410205800:web:be7a720e1db73fb5547fdd"
  };

export default firebaseConfig;